// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3E%3Cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/footer_bg.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heder_cont {
  height: 96px;
}
.navbar {
  background-color: #2f2e2e;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 999;
}
.navbar .navbar-nav {
  flex: 1 1;
  justify-content: center;
}
.header .navbar-nav .nav-link {
  color: #fff;
  font-size: 0.86rem;
  padding: 0.5rem 0;
  line-height: 1;
  margin: 0 1rem;
}
.header .navbar-nav .nav-link:hover,
.header .navbar-nav .nav-link.show,
.header .navbar-nav .nav-link.active,
.heder_cont .dropdown-menu .dropdown-item:hover {
  color: #b0aaa9;
  transition: color 0.5s ease-in-out;
}
.heder_cont .dropdown-menu {
  background-color: #2f2e2e;
  border: 0;
}
.heder_cont .dropdown-menu .dropdown-item {
  color: #fff;
  font-size: 0.84rem;
}
.heder_cont .dropdown-menu .dropdown-item:hover {
  background-color: transparent;
}
.heder_cont .navbar-collapse {
  align-items: flex-start;
}
.heder_cont .dropdown-toggle::after {
  display: none;
}
.header .dropdown:hover .dropdown-menu {
  display: block;
}

.header_sl > a {
  width: 3rem;
  height: 3rem;
  text-align: center;
  line-height: 3rem;
  color: #2f2e2e;
  background-color: #fff;
  border-radius: 50%;
  margin: 0 0.2rem;
}
.navbar-dark,
.navbar[data-bs-theme="dark"],
[data-bs-theme="dark"] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.footer {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center center no-repeat;
  background-size: cover;
  background-attachment: fixed;
}

.footer_top {
  padding: 3rem 0;
}
.footer_bottom {
  padding: 2rem 0;
  background-color: #2f2e2e;
}
.fc_details {
  font-weight: 500;
}
.lead_modal_middle_text {
  font-size: 20px;
  font-weight: 100;
}
.lead_modal_button {
  padding: 15px;
  width: 100%;
  font-size: 30px;
}
.lead_modal_form {
  padding-left: 110px;
  padding-right: 110px;
}
.full_content_modal {
  font-family: "sans-serif", "Barlow";
}
.lead_modal_href {
  color: inherit;
}

@media screen and (max-width: 1024px) {
  .header_sl > a {
    width: 2rem;
    height: 2rem;
    line-height: 2rem;
  }
  .navbar-brand img {
    width: 80px;
  }
  .heder_cont {
    height: 70px;
  }
}

@media screen and (max-width: 991px) {
  .navbar .navbar-nav {
    display: block;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/reffer/referal_header.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,OAAO;EACP,QAAQ;EACR,MAAM;EACN,YAAY;AACd;AACA;EACE,SAAO;EACP,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;AACA;;;;EAIE,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;;EAGE,oEAAwR;AAC1R;;AAEA;EACE,2EAA6E;EAC7E,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":[".heder_cont {\n  height: 96px;\n}\n.navbar {\n  background-color: #2f2e2e;\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  z-index: 999;\n}\n.navbar .navbar-nav {\n  flex: 1;\n  justify-content: center;\n}\n.header .navbar-nav .nav-link {\n  color: #fff;\n  font-size: 0.86rem;\n  padding: 0.5rem 0;\n  line-height: 1;\n  margin: 0 1rem;\n}\n.header .navbar-nav .nav-link:hover,\n.header .navbar-nav .nav-link.show,\n.header .navbar-nav .nav-link.active,\n.heder_cont .dropdown-menu .dropdown-item:hover {\n  color: #b0aaa9;\n  transition: color 0.5s ease-in-out;\n}\n.heder_cont .dropdown-menu {\n  background-color: #2f2e2e;\n  border: 0;\n}\n.heder_cont .dropdown-menu .dropdown-item {\n  color: #fff;\n  font-size: 0.84rem;\n}\n.heder_cont .dropdown-menu .dropdown-item:hover {\n  background-color: transparent;\n}\n.heder_cont .navbar-collapse {\n  align-items: flex-start;\n}\n.heder_cont .dropdown-toggle::after {\n  display: none;\n}\n.header .dropdown:hover .dropdown-menu {\n  display: block;\n}\n\n.header_sl > a {\n  width: 3rem;\n  height: 3rem;\n  text-align: center;\n  line-height: 3rem;\n  color: #2f2e2e;\n  background-color: #fff;\n  border-radius: 50%;\n  margin: 0 0.2rem;\n}\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"],\n[data-bs-theme=\"dark\"] .navbar-toggler-icon {\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3E%3Cpath stroke='rgba(255, 255, 255, 0.55)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\");\n}\n\n.footer {\n  background: url(\"../../assets/images/footer_bg.webp\") center center no-repeat;\n  background-size: cover;\n  background-attachment: fixed;\n}\n\n.footer_top {\n  padding: 3rem 0;\n}\n.footer_bottom {\n  padding: 2rem 0;\n  background-color: #2f2e2e;\n}\n.fc_details {\n  font-weight: 500;\n}\n.lead_modal_middle_text {\n  font-size: 20px;\n  font-weight: 100;\n}\n.lead_modal_button {\n  padding: 15px;\n  width: 100%;\n  font-size: 30px;\n}\n.lead_modal_form {\n  padding-left: 110px;\n  padding-right: 110px;\n}\n.full_content_modal {\n  font-family: \"sans-serif\", \"Barlow\";\n}\n.lead_modal_href {\n  color: inherit;\n}\n\n@media screen and (max-width: 1024px) {\n  .header_sl > a {\n    width: 2rem;\n    height: 2rem;\n    line-height: 2rem;\n  }\n  .navbar-brand img {\n    width: 80px;\n  }\n  .heder_cont {\n    height: 70px;\n  }\n}\n\n@media screen and (max-width: 991px) {\n  .navbar .navbar-nav {\n    display: block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
